// extracted by mini-css-extract-plugin
export default {"wrapper":"QuestionnaireWrapper_wrapper__Wo04m","innerWrapper":"QuestionnaireWrapper_innerWrapper__qtwtE"};